import * as React from "react";
import { Link } from "react-router";
import { BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Medallion mark (two rotated emerald squares, the 8-point star) and the
 * "hifzacademy" wordmark. Flat colour only: no gradient, no hover motion.
 */
const Logo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Link
      to="/"
      aria-label="Hifz Academy, početna stranica"
      className={cn(
        "pressable inline-flex min-h-11 shrink-0 select-none items-center gap-2.5 rounded-lg",
        className
      )}
    >
      <span aria-hidden className="relative grid size-9 shrink-0 place-items-center">
        <span className="absolute inset-0.5 rounded-[6px] bg-emerald-900" />
        <span className="absolute inset-0.5 rotate-45 rounded-[6px] bg-emerald-900" />
        <BookOpen className="relative size-4 text-gold-300" />
      </span>
      <span aria-hidden className="text-xl font-bold tracking-tight">
        <span className="text-emerald-900">hifz</span>
        <span className="font-medium tracking-tighter text-emerald-600">
          academy
        </span>
      </span>
    </Link>
  );
};

export default Logo;
